(function(){
'use strict';
var K={tab:'zingiez:tablets',fl:'zingiez:flavor',nm:'zingiez:name',em:'zingiez:email'};
var get=function(k,d){try{return localStorage.getItem(k)||d}catch(e){return d}};
var set=function(k,v){try{localStorage.setItem(k,v)}catch(e){}};
var $=function(s,r){return (r||document).querySelector(s)};
var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var reduced=window.matchMedia('(prefers-reduced-motion:reduce)').matches;

/* ---------- cart ---------- */
function addToCart(id,qty,btn){
  var t=btn?btn.textContent:'';
  if(btn){btn.disabled=true;btn.textContent='adding\u2026';}
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty||1}]})})
    .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
    .then(function(){window.location.href='/cart'})
    .catch(function(){if(btn){btn.disabled=false;btn.textContent='try again';setTimeout(function(){btn.textContent=t},1800)}});
}
document.addEventListener('click',function(e){
  var b=e.target.closest('[data-add]');
  if(!b)return;
  e.preventDefault();
  var q=b.getAttribute('data-qty')||($('[name=quantity]',b.closest('form,section,div')||document)||{}).value||1;
  addToCart(parseInt(b.getAttribute('data-add'),10),parseInt(q,10)||1,b);
});

/* ---------- newsletter ---------- */
$$('[data-signup]').forEach(function(f){
  f.addEventListener('submit',function(e){
    e.preventDefault();
    var n=(f.querySelector('[name=first_name]')||{}).value||'',em=(f.querySelector('[name=email]')||{}).value||'';
    if(n.trim())set(K.nm,n.trim());
    if(em.trim())set(K.em,em.trim());
    var btn=f.querySelector('button');
    if(btn){btn.textContent="you're in";btn.disabled=true}
  });
});

/* ---------- welcome back ---------- */
(function(){
  var host=$('[data-welcome]');if(!host)return;
  var name=get(K.nm,''),tab=get(K.tab,'');
  if(!name)return;
  var line=tab?('last time you landed on '+tab+' tablets.'):'good to see you again.';
  host.innerHTML='<div class="wrap" style="display:flex;gap:16px;align-items:center;justify-content:space-between;flex-wrap:wrap">'+
    '<div><div class="lab" style="font-size:10px;opacity:.6;margin-bottom:4px">welcome back</div>'+
    '<div style="font-family:Tosh;font-weight:900;font-size:22px">'+name.replace(/[<>]/g,'')+'. '+line+'</div></div>'+
    '<div style="display:flex;gap:10px;flex-wrap:wrap">'+(tab?'<a class="btn btn-y" style="padding:11px 22px;font-size:14px" href="/pages/how-it-works#dial">set the dial to '+tab+'</a>':'')+
    '<button data-forget class="btn btn-o" style="padding:11px 22px;font-size:14px;border-color:rgba(255,255,255,.5);color:#fff">not you?</button></div></div>';
  host.style.display='block';
  var f=$('[data-forget]',host);
  if(f)f.addEventListener('click',function(){try{localStorage.removeItem(K.nm)}catch(e){}host.style.display='none'});
})();

/* ---------- the dial ---------- */
(function(){
  var svg=$('#zdial');if(!svg)return;
  var C=280,R=248,MIN=1,MAX=40;
  var t=parseInt(get(K.tab,'10'),10);if(!(t>=MIN&&t<=MAX))t=10;
  var ang=function(f){return (-225+270*f)*Math.PI/180};
  var pt=function(f,r){return [C+r*Math.cos(ang(f)),C+r*Math.sin(ang(f))]};
  function arc(f1,f2,r){var a=pt(f1,r),b=pt(f2,r);return 'M '+a[0]+' '+a[1]+' A '+r+' '+r+' 0 '+(((f2-f1)*270>180)?1:0)+' 1 '+b[0]+' '+b[1]}
  var NS='http://www.w3.org/2000/svg';
  function el(n,a){var e=document.createElementNS(NS,n);for(var k in a)e.setAttribute(k,a[k]);return e}
  function paint(){
    var frac=(t-MIN)/(MAX-MIN),hot=t>20,accent=hot?'#e51a4b':'#294a22';
    while(svg.firstChild)svg.removeChild(svg.firstChild);
    svg.appendChild(el('path',{d:arc(0,1,R),stroke:'rgba(17,17,17,.12)','stroke-width':10,fill:'none','stroke-linecap':'round'}));
    svg.appendChild(el('path',{d:arc(19/39,1,R),stroke:'rgba(229,26,75,.18)','stroke-width':10,fill:'none','stroke-linecap':'round'}));
    svg.appendChild(el('path',{d:arc(0,Math.max(frac,.001),R),stroke:accent,'stroke-width':10,fill:'none','stroke-linecap':'round'}));
    for(var i=MIN;i<=MAX;i++){
      var f=(i-MIN)/(MAX-MIN),major=[1,5,10,20,30,40].indexOf(i)>-1;
      var p1=pt(f,R-(major?34:22)),p2=pt(f,R-12);
      svg.appendChild(el('line',{x1:p1[0],y1:p1[1],x2:p2[0],y2:p2[1],stroke:i<=t?accent:'rgba(17,17,17,.22)','stroke-width':major?4:2,'stroke-linecap':'round'}));
      if(major){var p3=pt(f,R-56),tx=el('text',{x:p3[0],y:p3[1],fill:'#6f6e6a','font-size':16,'font-family':'Bureau','text-anchor':'middle','dominant-baseline':'middle'});tx.textContent=i*5;svg.appendChild(tx)}
    }
    var h=pt(frac,R);
    svg.appendChild(el('circle',{cx:h[0],cy:h[1],r:19,fill:accent,stroke:'#fff','stroke-width':6}));
    sync();
  }
  function sync(){
    var mg=t*5,hot=t>20;
    $$('[data-tablets]').forEach(function(e){e.textContent=t});
    $$('[data-mg]').forEach(function(e){e.textContent=mg});
    var lab=$('#doselabel');
    if(lab)lab.textContent=t>=40?'the ceiling':t>=20?'full send':t>=10?'locked in':t>=5?'warm up':'a whisper';
    var srv=$('#servingline');
    if(srv){var s=Math.round(t/10*10)/10;srv.textContent=(s===1?'one serving':s+' servings')}
    var bar=$('#ceilingbar');
    if(bar){bar.style.width=Math.round(t/40*100)+'%';bar.style.background=hot?'#e51a4b':'#294a22'}
    var note=$('#ceilingnote');
    if(note){note.textContent=t>=40?"that's the max: 40 tablets / 200mg per day. the label says 4 servings, and so do we.":t>20?('that\u2019s '+t+' of the 40 tablets the label allows per day. more isn\u2019t better, it\u2019s just more.'):'';note.style.display=t>20?'block':'none'}
    var sl=svg.closest('[role=slider]');
    if(sl){sl.setAttribute('aria-valuenow',t);sl.setAttribute('aria-valuetext',t+' tablets, '+mg+' milligrams of caffeine')}
    $$('.g100 i').forEach(function(c,i){c.classList.toggle('on',i<t)});
    set(K.tab,String(t));
  }
  function setT(n){t=Math.max(MIN,Math.min(MAX,Math.round(n)));paint()}
  window.zDialTo=function(n){setT(n);var s=$('#dial');if(s)s.scrollIntoView({behavior:reduced?'auto':'smooth',block:'start'})};
  function fromPoint(ev){
    var b=svg.getBoundingClientRect(),x=ev.clientX-(b.left+b.width/2),y=ev.clientY-(b.top+b.height/2);
    var a=(Math.atan2(y,x)*180/Math.PI-135+360)%360;
    var f=a<=270?a/270:(a<315?1:0);
    setT(MIN+f*(MAX-MIN));
  }
  svg.addEventListener('pointerdown',function(e){
    e.preventDefault();svg.setPointerCapture(e.pointerId);fromPoint(e);
    var mv=function(ev){fromPoint(ev)},up=function(){svg.removeEventListener('pointermove',mv);svg.removeEventListener('pointerup',up);svg.removeEventListener('pointercancel',up)};
    svg.addEventListener('pointermove',mv);svg.addEventListener('pointerup',up);svg.addEventListener('pointercancel',up);
  });
  var sl=svg.closest('[role=slider]');
  if(sl)sl.addEventListener('keydown',function(e){
    var m={ArrowRight:1,ArrowUp:1,ArrowLeft:-1,ArrowDown:-1,PageUp:5,PageDown:-5};
    if(e.key==='Home'){e.preventDefault();setT(MIN)}
    else if(e.key==='End'){e.preventDefault();setT(MAX)}
    else if(m[e.key]){e.preventDefault();setT(t+m[e.key])}
  });
  $$('[data-dial]').forEach(function(b){b.addEventListener('click',function(){window.zDialTo(parseInt(b.getAttribute('data-dial'),10))})});
  var grid=$('.g100');
  if(grid){
    var sweeping=false;
    var at=function(ev){
      var b=grid.getBoundingClientRect();
      var col=Math.floor((ev.clientX-b.left)/b.width*10),row=Math.floor((ev.clientY-b.top)/b.height*10);
      if(col<0||col>9||row<0||row>9)return;
      setT(Math.min(row*10+col+1,MAX));
    };
    grid.addEventListener('pointerdown',function(e){sweeping=true;grid.setPointerCapture(e.pointerId);at(e)});
    grid.addEventListener('pointermove',function(e){if(sweeping)at(e)});
    grid.addEventListener('pointerup',function(){sweeping=false});
    grid.addEventListener('pointercancel',function(){sweeping=false});
  }
  paint();
})();

/* ---------- pdp: gallery, subscribe, qty ---------- */
(function(){
  var g=$('[data-gallery]');if(g){
    $$('[data-thumb]',g).forEach(function(th){th.addEventListener('click',function(){
      $('[data-main]',g).src=th.getAttribute('data-thumb');
      $$('[data-thumb]',g).forEach(function(o){o.style.borderColor='var(--hair)'});
      th.style.borderColor='var(--forest)';
    })});
  }
  var qi=$('[name=quantity]');
  $$('[data-q]').forEach(function(b){b.addEventListener('click',function(){
    if(!qi)return;var v=parseInt(qi.value,10)||1;
    qi.value=Math.max(1,Math.min(10,v+parseInt(b.getAttribute('data-q'),10)));
  })});
  $$('[data-plan]').forEach(function(r){r.addEventListener('change',function(){
    $$('[data-plan]').forEach(function(o){var w=o.closest('label');if(w)w.style.borderColor=o.checked?'var(--ink)':'var(--hair)';if(w)w.style.borderWidth=o.checked?'2px':'1.5px'});
    var lbl=$('[data-buylabel]'),price=r.getAttribute('data-price'),word=r.getAttribute('data-word');
    if(lbl)lbl.textContent=word+' \u00b7 '+price;
    var sb=$('[data-stickylabel]');if(sb)sb.textContent=word+' \u00b7 '+price;
  })});
  var checked=$('[data-plan]:checked');if(checked)checked.dispatchEvent(new Event('change'));
})();

/* ---------- accordions ---------- */
$$('[data-acc]').forEach(function(h){
  var body=h.nextElementSibling;if(!body)return;
  body.style.display='none';
  h.setAttribute('aria-expanded','false');
  h.addEventListener('click',function(){
    var open=body.style.display!=='none';
    body.style.display=open?'none':'block';
    h.setAttribute('aria-expanded',open?'false':'true');
    var ic=$('[data-accicon]',h);if(ic)ic.style.transform=open?'rotate(0deg)':'rotate(45deg)';
  });
});

/* ---------- blog tag filter ---------- */
(function(){
  var bar=$('[data-tags]');if(!bar)return;
  $$('button',bar).forEach(function(b){b.addEventListener('click',function(){
    var tag=b.getAttribute('data-tag');
    $$('button',bar).forEach(function(o){o.style.background=o===b?'var(--ink)':'#fff';o.style.color=o===b?'#fff':'var(--ink)'});
    $$('[data-posttag]').forEach(function(p){p.style.display=(!tag||p.getAttribute('data-posttag')===tag)?'':'none'});
  })});
})();

/* ---------- ingredient tooltips ---------- */
(function(){
  var tips={caffeine:'the classic. 5mg per tablet, so the dose is always yours to build. a cup of coffee is roughly 70 to 140mg.',theanine:'an amino acid found in tea leaves. 10mg per tablet, twice the caffeine. it is there to prevent the crash.',terpene:'aromatic plant oils. 2.5mg a serving, nano emulsified so they spread evenly through all 100 tablets.',sugar:'sweetened with sugar alcohol instead of sugar. 0g total sugars, 5 calories a serving.'};
  var nodes=$$('[data-ing]');if(!nodes.length)return;
  var tip=document.createElement('div');
  tip.style.cssText='position:fixed;z-index:99;max-width:280px;background:#111;color:#fff;border-radius:14px;padding:12px 16px;font:14px/1.5 Tosh,sans-serif;box-shadow:0 12px 30px rgba(0,0,0,.35);pointer-events:none;opacity:0;transition:opacity .15s';
  document.body.appendChild(tip);
  nodes.forEach(function(n){
    n.style.cssText+=';text-decoration:underline dotted;text-underline-offset:3px;cursor:help';
    n.addEventListener('mouseenter',function(){tip.textContent=tips[n.getAttribute('data-ing')]||'';tip.style.opacity='1'});
    n.addEventListener('mousemove',function(e){tip.style.left=Math.min(e.clientX+14,window.innerWidth-300)+'px';tip.style.top=(e.clientY+16)+'px'});
    n.addEventListener('mouseleave',function(){tip.style.opacity='0'});
  });
})();
})();